import React from 'react';
import './Popup.css';
import CallBack from '../causeBranding/CallBack';

function Popup({ showPopup, togglePopup }) {
  return (
    showPopup && (
      <div className="popup-container">
        <div className="popup">
          <CallBack />
          <span className="close-btn" onClick={togglePopup}>
            &times;
          </span>
        </div>
      </div>
    )
  );
}

export default Popup;
